<template>
  <p class="text-field">
    <input type="text" class="text-field__input" autocomplete="off"
           :required="data.required"
           v-validate="data.validationRule"
           :class="{'input': true, 'is-danger': errors.has(data.id) }"
           :id="data.id"
           :name="data.id"
           :placeholder="data.placeholder">
    <transition name="fade" mode="in-out">
      <span v-show="errors.has(data.id)" class="mail-field__error-message">{{ errors.first(data.id) }}</span>
    </transition>
    <label class="text-field__label" :for="data.id">
      {{data.label}}
    </label>
  </p>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    data: Object
  }
}
</script>

<style lang="scss">
  .text-field {
    position: relative;
    display: flex;
    margin: 0;
    flex-wrap: wrap;
    max-width: 390px;
    justify-content: flex-end;
    align-items: center;

    &__input {
      display: block;
      width: 300px;
      padding: 8.6px 12px 6px 7.4px;
      border: 1px solid #ebedf2;
      border-radius: 3px;
      transition: 250ms ease-in;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 300;
      color: #999999;
      line-height: 21px;
      opacity: 1;
      resize: none;

      &:focus {
        outline: 0;
        border-color: #554dbd;
      }

      :disabled {
        background-color: #f4f5f8;
      }

      ::placeholder {
        opacity: 1;
        color: #999999;
      }
    }

    &__label {
      order: -1;
      margin-top: 1px;
      margin-right: 20px;
      font-size: 14px;
      line-height: 21px;
      color: #333333;
    }

    &__error-message {
      position: absolute;
      bottom: -22px;
      font-size: 14px;
      font-weight: 300;
      line-height: 21px;
      color: #f4516c;
      width: 300px;
    }
  }
</style>
